export { default } from './CopyPaste';
